import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import routesView from './routesView.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'museumPremialitaModule',
    props: {
        museumId: {
            type: String,
        },
        sortOnly: {
            type: Boolean,
        },
        token: {
            type: String,
        },
        baseUrl: {
            type: String
        },
        languageJson: {
            type: Array
        },
        router: {
            type: Object
        },
        route: {
            type: Object
        },
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(routesView, {
                museumId: props.museumId,
                baseUrl: props.baseUrl,
                token: props.token,
                languageJson: props.languageJson,
                router: props.router,
                route: props.route
            }, null, 8, ["museumId", "baseUrl", "token", "languageJson", "router", "route"]));
        };
    }
});
